// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo img {\n  height: 40px;\n}\n@media (max-width: 768px) {\n.logo img {\n    height: 30px;\n}\n}", ""]);
// Exports
module.exports = exports;
